import categoryList from '@mooveguru/yhh-shared-config/marketplace-categories.json';

/**
 * @typedef {keyof typeof categoryList} Key
 * @typedef {typeof categoryList[Key]} Label
 */

/**
 * @param {string} key
 * @returns {Label | undefined}
 */
export function getCategoryLabel(key) {
	if (Object.prototype.hasOwnProperty.call(categoryList, key)) {
		return categoryList[/** @type {Key} */ (key)];
	}

	return undefined;
}

/**
 * @param {string} label
 * @returns {Key | null}
 */
export function getCategoryValue(label) {
	const entries = /** @type {[Key, Label][]} */ (
		Object.entries(categoryList)
	);

	for (const [key, value] of entries) {
		if (value === label) {
			return key;
		}
	}

	return null;
}
